import {prepareEnvironment} from "./environment.prod.base";
import {LANGUAGE_EN} from "../../shared/language";
import {ChatVersions} from "../../shared/chat.versions";
import translations from '../assets/i18n/en.json';

const domain = '18sexchat.net'

export let environment = prepareEnvironment(LANGUAGE_EN, translations, domain, ChatVersions.SX, 'G-4V893K3ZF6')